import ConsumptionSection from '../components/consumption-section/ConsumptionSection.tsx'
import { ENERGY_TYPES } from '@boltenergy-be/shared'

const GasConsumption = () => {
  return <ConsumptionSection energyType={ENERGY_TYPES.gas} />
}

export default GasConsumption
